import { Column, PageLayout, Row } from '@/components'
import { ThemeColor } from '@/enums'
import { themeBreakpointDown, themeColor, toThemePixels } from '@/utils'
import styled, { keyframes } from 'styled-components'

export const SuccessPageContainer = styled(PageLayout)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${toThemePixels(12)};
  background: ${themeColor(ThemeColor.b0)};
  padding: ${toThemePixels(4)};
`

export const SuccessPageHeader = styled.div`
  max-width: 1080px;
  width: 100%;
  gap: ${toThemePixels(4)};
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  grid-gap: ${toThemePixels(8)};
  margin-bottom: ${toThemePixels(5)};

  button {
    align-self: flex-start;
  }

  @media (max-width: 820px) {
    display: flex;
    flex-direction: column;
  }
`

export const ImageContainer = styled.div`
  max-height: 396px;
  justify-self: center;

  img {
    width: auto;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 820px) {
    img {
      width: 100%;
    }
  }
`

export const ThankYouPageContainer = styled(Column)`
  padding-top: ${toThemePixels(32)};
  background: ${themeColor(ThemeColor.b10)};
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  gap: ${toThemePixels(23)};
  padding-bottom: ${toThemePixels(30)};
`

export const ThankYouTextContainer = styled(Column)`
  max-width: 550px;
  align-items: center;
  text-align: center;
  gap: ${toThemePixels(3)};
  padding: ${toThemePixels(2)};
`

export const IconBackground = styled(Column)`
  background: ${themeColor(ThemeColor.success1)};
  border-radius: 50%;
  justify-content: center;
  justify-content: center;
  align-items: center;
  height: 64px;
  width: 64px;
`

const showAnimation = keyframes`
 0% { max-height: 0; display: none;}
 50% { max-height: 0; display: none;}
 100% { max-height: 2500px;}
`

export const ThankYouPageAnimationContainer = styled.div`
  overflow: hidden;
  animation-name: ${showAnimation};
  animation-duration: 6s;
  animation-fill-mode: forwards;

  ${themeBreakpointDown('sm')} {
    width: 100%;
  }
`

export const StyledSSL = styled(Row)`
  width: fit-content;
  border-radius: ${toThemePixels(2)};
  span {
    font-weight: 500;
  }
`

export const CheckIconBackground = styled(Column)`
  background: ${themeColor(ThemeColor.success3)};
  border-radius: 50%;
  justify-content: center;
  justify-content: center;
  align-items: center;
  height: 48px;
  width: 48px;

  > svg {
    color: ${themeColor(ThemeColor.success1)};
  }
`

export const ButtonsContainer = styled(Row)`
  gap: ${toThemePixels(6)};
  margin-top: ${toThemePixels(6)};
`
